import { AutomationPlaceholderLabels, AutomationType } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type AutomationApiType = ReturnType<typeof automationApi>;

const automationApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    find() {
      return axiosInstance.get(`${clubPrefix}automation`);
    },
    updateBCC(id: number, bccList: string[]) {
      return axiosInstance.patch(`${clubPrefix}automation/${id}/bcc`, {
        bccList,
      });
    },
    active(id: number) {
      return axiosInstance.patch(`${clubPrefix}automation/${id}/active`);
    },
    inactive(id: number) {
      return axiosInstance.patch(`${clubPrefix}automation/${id}/inactive`);
    },
    placeholderLabels(placeholderType: AutomationType = "GENERIC") {
      return axiosInstance.get<AutomationPlaceholderLabels>(
        `${clubPrefix}automation/placeholder-labels/${placeholderType}`,
      );
    },
  };
};

export default automationApi;
